import { useRef, useMemo, useState } from 'react';
import Select, { components } from 'react-select';

const SearchableDropdown = ({
  options,
  isMulti = false,
  label,
  defaultValue,
  onDelete = () => {},
  onSelect = () => {},
}) => {
  const previousValue = useRef(defaultValue || []);
  const selectRef = useRef(null);
  const selectAllOption = { label: 'Select All', value: '*' };
  const allOptions = useMemo(() => {
    const selected = previousValue.current || [];

    // If all options (excluding Select All) are already selected, don't show Select All
    const showSelectAll = selected.length < options.length;

    return isMulti
      ? (showSelectAll ? [selectAllOption, ...options] : options)
      : options;
  }, [options, isMulti]);


  const handleChange = (selected) => {
    const current = Array.isArray(selected) ? selected : [];
    const prev = Array.isArray(previousValue.current) ? previousValue.current : [];

    const isSelectAll = current.some((opt) => opt.value === '*');

    let finalSelected = current;

    if (isSelectAll) {
      // toggle all
      if (prev.length === options.length) {
        finalSelected = [];
      } else {
        finalSelected = [...options];
      }

      // close the dropdown menu
      selectRef.current?.blur();
    }

    const added = finalSelected.filter(
      (curr) => !prev.some((p) => p.value === curr.value)
    );
    const removed = prev.filter(
      (p) => !finalSelected.some((curr) => curr.value === p.value)
    );

    added.forEach(({ value }) => onSelect(value));
    removed.forEach(({ value }) => onDelete(value));

    previousValue.current = finalSelected;
  };

  const getValue = () => {
    if (!isMulti) return defaultValue;
    const selected = previousValue.current || [];
    return selected.filter((item) => item.value !== '*');
  };

  const Option = (props) => {
    const { data, isSelected, innerRef, innerProps, selectOption } = props;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          selectOption(data);
        }}
        style={{
          backgroundColor: props.isFocused ? '#eee' : 'white',
          padding: '8px 12px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <input
          type="checkbox"
          checked={isSelected}
          readOnly
          style={{ marginRight: 8 }}
        />
        {data.label}
      </div>
    );
  };

  return (
    <div className="mb-3">
      {label && <label>{label}</label>}
      <Select
        ref={selectRef}
        defaultValue={defaultValue}
        options={allOptions}
        isMulti={isMulti}
        onChange={handleChange}
        value={getValue()}
        components={isMulti ? { Option } : undefined}
        closeMenuOnSelect={false}
        menuPortalTarget={document.body}
        styles={{
          container: (base) => ({
            ...base,
            width: '100%'
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }}
      />
    </div>
  );
}

export default SearchableDropdown;